(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-buttons.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-buttons.js');

'use strict';

const Button = svs.ui.ReactButton;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const ButtonHowTo = svs.lotto.react.components.ButtonHowTo;
const StartButtons = () => {
  const handleClick = page => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_gameEntry',
      opt_label: page
    }, () => {
      const url = page.toLowerCase().replace(/ /g, '-').replace(/ö/g, 'o').replace(/ä/g, 'a');
      svs.utils.url.navigate("lotto/".concat(url));
    });
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "start-buttons js-start-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, !isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Förläng spel'),
    type: "button"
  }, "F\xF6rl\xE4ng spel"), !isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Resultat'),
    type: "button"
  }, "Resultat"), !isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Andelsspel'),
    type: "button"
  }, "Andelsspel"), !isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Systemspel'),
    type: "button"
  }, "Systemspel"), !isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Prenumeration'),
    type: "button"
  }, "Prenumeration"), !isSelfService && React.createElement(ButtonHowTo, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Spelguide')
  }), isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Systemspel'),
    type: "button"
  }, "Systemspel"), isSelfService && React.createElement(Button, {
    className: "btn btn-lotto",
    onClick: () => handleClick('Resultat'),
    type: "button"
  }, "Resultat"))), isSelfService && React.createElement("div", {
    className: "button-wrapper"
  }, React.createElement("div", {
    className: "wrapper-body"
  }, React.createElement(ButtonHowTo, null))));
};
setGlobal('svs.lotto.react.components', {
  StartButtons
});

 })(window);